/*
 * Public API Surface of web-reader-lib
 */

export * from './lib/web-reader-lib';
export * from './lib/models/reader-document';
export * from './lib/registry/widget-registry.token';
export * from './lib/registry/default-widget-registry';
export * from './lib/reader-shell/reader-shell.component';